import { ColumnDef } from '@tanstack/react-table';
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { Badge, Divider, Flex, Text } from 'theme-ui';
import queryString from 'query-string';
import { FolderOption, RootState, usersProps } from '../../../../@types';
import { GetProjectList, UpdateProjectRow } from '../../../store/actions/project.action';
import { getAllUserWithoutPagination } from '../../../store/actions/user.action';
import { capitalize, getApiEndPoint } from '../../../utils/GenerateQueryString';
import DataTable from '../../Tabels/Tabel';
import { ProjectViewHeader } from '../../Text/ProjectViewHeader';
import Export from "../../assets/images/Icon/Export.svg";
import CommentsDialogBox from './CommentSection';
import { ProjectName } from './ProjectName';
import editIcon from "../../assets/images/Icon/highlightericon.svg";
import { useQuery } from '@tanstack/react-query';
import { baseUrl } from '../../../utils/global';
import { statusColors } from '../../../utils/constent';

const Index: React.FC = () => {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams({
        currentPage: "1",
        limit: "15",
    });

    const limit = parseInt(searchParams.get('limit') || "15");
    const currentPage = parseInt(searchParams.get('currentPage') || "1");
    const { projectList, loader, highlighters } = useSelector((state: any) => state.project);
    // const { paginations } = useSelector((state: any) => state.pagination);
    const { dataForTable, masterdataByKeys } = useSelector((state: RootState) => state.masterData);
    const { userData } = useSelector((state: RootState) => state.user);
    const { auther } = useSelector((state: RootState) => state.auth);
    const location = useLocation();
    const parsedQuery = queryString.parse(location.search);

    const { data: eventSource } = useQuery({
        queryKey: ['projectSSE'],
        queryFn: () => {
            const eventSource = new EventSource(`${baseUrl}sse/project`);

            eventSource.onmessage = (event) => {
                try {
                    const data = JSON.parse(event.data);
                    dispatch(UpdateProjectRow(data))
                } catch (error) {
                    console.error('Error parsing SSE data:', error);
                }
            };

            eventSource.onerror = (error) => {
                console.error('SSE Error:', error);
                eventSource.close();
            };
            return eventSource;
        },
        refetchInterval: 60000
    })
    useEffect(() => {
        return () => {
            eventSource?.close();
        };
    }, [])
    const generateFolderOptions = (): FolderOption[] => {
        const startMonth = 1609;
        const currentYear = new Date().getFullYear() % 100;
        const currentMonth = new Date().getMonth() + 1;
        // console.log('Current Year:', currentYear);
        // console.log('Current Month:', currentMonth);
        const folderOptions: FolderOption[] = [];
        for (let year = 16; year <= currentYear; year++) {
            const start = (year === 16) ? startMonth % 100 : 1;
            const end = (year === currentYear) ? currentMonth + 2 : 12;
            for (let month = start; month <= end; month++) {
                const formattedOption = `projects_${year.toString().padStart(2, '0')}${month.toString().padStart(2, '0')}`;
                const optionObject: FolderOption = { label: formattedOption, value: formattedOption };
                folderOptions.push(optionObject);
                if (year === currentYear && month === currentMonth) {
                    optionObject.defaultSelected = true;
                }
            }
        }
        folderOptions.sort((a, b) => a.label.localeCompare(b.label));
        return folderOptions;
    };

    const columns = useMemo<ColumnDef<any>[]>(() => [
        // {
        //     accessorKey: "id",
        //     id: "select",
        //     enableColumnFilter: false,
        //     header: ({ table }) => (
        //         <div className="d-flex justify-content-center">
        //             <IndeterminateCheckbox
        //                 {...{
        //                     checked: table.getIsAllRowsSelected(),
        //                     indeterminate: table.getIsSomeRowsSelected(),
        //                     onChange: table.getToggleAllRowsSelectedHandler(),
        //                 }}
        //             />
        //         </div>
        //     ),
        //     cell: ({ row }) => (
        //         <IndeterminateCheckbox
        //             {...{
        //                 checked: row.getIsSelected(),
        //                 disabled: !row.getCanSelect(),
        //                 indeterminate: row.getIsSomeSelected(),
        //                 onChange: row.getToggleSelectedHandler(),
        //             }}
        //         />
        //     ),
        // },
        {
            header: 'No',
            enableColumnFilter: false,
            accessorKey: "no",
            cell: ({ row }) => {
                return (
                    <div className='d-flex p-1 text-center' style={{ justifyContent: 'space-between' }}>
                        <Text variant='Poppins14Normal24lh'>{((currentPage - 1) * limit) + row?.index + 1}</Text>
                        {row?.original?.status === 'draft' ? <img src={editIcon} alt='' style={{ cursor: 'pointer' }} onClick={() => { navigate(`/create-project?step=2&id=${row?.original?._id}`) }} /> : ''}
                    </div >
                )
            }
        },
        {
            accessorKey: "name",
            header: 'Project name',
            cell: ({ row }) => {
                return (
                    // <Text onClick={(): void => {
                    //     setIsOpen(true);
                    //     setProjectId(row?.original?._id)
                    // }} style={{ textDecoration: 'none', color: '#0A0A0A', cursor: "pointer" , borderBottom:'2px solid green'}}>
                    //     {row?.original?.name || ''}
                    // </Text>
                    <ProjectName
                        original={row?.original}
                        projectId={row?.original?._id}
                        projectName={row?.original?.name || ''}
                    />
                )
            },
            filterType: "dropdown",
            options: (() => {
                if (parsedQuery?.status == "Delivered" || parsedQuery?.status == "IPR Delivered") {
                    return masterdataByKeys?.data?.allDeliveredProjects?.map((val: { _id: string, name: string }) => ({ value: val._id, label: val.name }));
                } else if (parsedQuery?.status == "Ready To Deliver" || parsedQuery?.status == "IPR Ready To Deliver") {
                    return masterdataByKeys?.data?.allRTDProjects?.map((val: { _id: string, name: string }) => ({ value: val._id, label: val.name }));
                } else if (parsedQuery?.status == "Draft") {
                    return masterdataByKeys?.data?.allDraftProjects?.map((val: { _id: string, name: string }) => ({ value: val._id, label: val.name }));
                } else {
                    return dataForTable?.data?.allProjects?.map((val: { _id: string, name: string }) => ({ value: val._id, label: val.name }));
                }
            })()

        },
        {
            header: 'Project Manager',
            accessorKey: "projectManager",
            cell: ({ row }) => {
                const pm = row.original.projectManager;
                const pmId = pm?._id || pm;
                const exists = dataForTable?.data?.allProjectManagers?.some((x: { _id: string }) => x._id === pmId);
                return (
                    <Text >{exists && pm ? `${pm.FirstName || ''} ${pm.LastName || ''}`.trim() : ""}</Text>
                )
            },
            filterType: 'dropdown',
            options: dataForTable?.data?.allProjectManagers?.map((val: { _id: string, FirstName: string, LastName: string }) => ({ value: val._id, label: `${val.FirstName} ${val.LastName}` }))
        },
        {
            header: 'Sales Representative',
            accessorKey: "salesRepresentative",
            cell: ({ row }) => {
                const rep = row.original.salesRepresentative;
                const repId = typeof rep === 'object' && rep !== null ? (rep as usersProps)._id : rep;
                const salesUserList = (userData?.data || []).filter((user: usersProps) =>
                    user?.departments?.some((dept: { name: string }) => dept?.name === 'SALES')
                );
                const exists = salesUserList.some((u: usersProps) => u._id === repId);
                return (
                    <Text>{exists && rep ? `${(rep as usersProps)?.FirstName || ''} ${(rep as usersProps)?.LastName || ''}`.trim() : ""}</Text>
                )
            },
            filterType: 'dropdown',
            options: (userData?.data || [])
                ?.filter((user: usersProps) => user?.departments?.some((dept: { name: string }) => dept?.name === 'SALES'))
                ?.map((val: usersProps) => ({ value: val._id, label: `${val.FirstName} ${val.LastName}` }))
        },
        {
            header: 'Architect',
            accessorKey: "architect",
            cell: ({ row }) => {
                return (
                    <Text >{row.original.architect?.name}</Text>
                )
            },
            filterType: 'dropdown',
            options: dataForTable?.data?.allArchitects?.map((val: { _id: string, name: string }) => ({ value: val._id, label: val.name }))
        },
        {
            header: 'Project Number',
            accessorKey: "folderNumber",
            cell: info => info.getValue(),
            filterType: 'dropdown',
            options: generateFolderOptions(),
        },
        {
            header: 'Stages Name list',
            accessorKey: 'stagesNameList',
            cell: ({ row }) => {
                const stages = row.original.stagesNameList;
                if (stages && stages.length > 0) {
                    return (
                        <div>
                            {stages?.map((val: { color: string, name: string, _id: string, temporaryName?: string }) => (
                                // <CommonSpan color={val.color} name={val.name} />
                                <Badge sx={{ color: `${val?.color}`, border: `1px solid ${val.color}`, borderRadius: 6, backgroundColor: "transparent", margin: "5px" }} key={val._id}>{val.temporaryName ? val.temporaryName : val.name}</Badge>
                            ))}
                        </div>
                    );
                } else {
                    return null;
                }
            },
            filterType: 'multi-select-dropdown',
            // filterType: "none",
            sticky: 'right',
            options: dataForTable?.data?.allStages?.map((val: { _id: string, name: string }) => ({ value: val._id, label: val.name }))
        },
        {
            header: 'Highlighters',
            accessorKey: "highlighters",
            // filterType: "textbox",
            cell: ({ row }) => {
                const stages = row.original.highlighters;
                if (stages && stages.length > 0) {
                    return (
                        <Flex sx={{ justifyContent: "center" }}>
                            {stages?.map((val: { color: string, title: string, _id: string, name: string }) => (
                                // <CommonSpan color={val.color} name={val.name} />
                                <Badge title={val.name} sx={{ color: `${val.color}`, border: `1px solid ${val.color}`, borderRadius: 6, backgroundColor: "transparent", margin: "5px" }} key={val._id}>{val.title}</Badge>
                            ))}
                        </Flex>
                    );
                } else {
                    return null;
                }
            },
            filterType: 'multi-select-dropdown',
            options: highlighters?.map((val: { _id: string, name: string }) => ({ value: val._id, label: val.name }))
        },
        {
            header: 'No. of Tasks',
            accessorKey: "numberOfTask",
            cell: info => info.getValue(),
            filterType: "none"
        },
        // {
        //     header: 'Estimated Time',
        //     accessorKey: "estimatedTime",
        //     cell: info => info.getValue(),
        // },
        {
            header: 'Quote Number',
            accessorKey: "quoteNumber",
            cell: info => info.getValue(),
            filterType: "number"
        },
        {
            header: 'Status',
            accessorKey: "status",
            cell: ({ row }) => {
                type StatusType = keyof typeof statusColors;

                const status = row.original.status as StatusType;

                const color = statusColors[status] || '#000';

                return (
                    <Badge
                        title={status}
                        sx={{
                            color: `white`,
                            border: `1px solid ${color}`,
                            borderRadius: 6,
                            backgroundColor: `${color}`,
                            margin: "5px"
                        }}
                    >
                        {status}
                    </Badge>
                );
            },
            filterType: 'dropdown',
            options: dataForTable?.data?.status?.map((val: { value: string }) => ({ value: val.value, label: capitalize(val.value) }))
        },
        {
            header: 'Comments',
            cell: ({ row }) => {
                return (
                    <CommentsDialogBox id={row?.original?._id} comments={row?.original} level="project" />
                );

            },
        }
    ], [projectList, dataForTable, masterdataByKeys, userData, auther]);
    const dispatch = useDispatch()
    // console.log(dataForTable, "check173");
    useEffect(() => {
        dispatch(getAllUserWithoutPagination());
        const parsedQuery = queryString.parse(location.search);
        let queryArray: any = [];
        let queryData = Object.keys(parsedQuery)?.map((val) => {
            queryArray.push([val, parsedQuery[val]])
        })
        // console.log(queryArray, "check241");
    }, [])
    useEffect(() => {
        let apiEndPoint = getApiEndPoint({ limit, currentPage }, location.search, columns?.map((val: any) => ({ accessorKey: val.accessorKey, filterType: val.filterType, header: val.header })))
        dispatch(GetProjectList(apiEndPoint))
    }, [location?.search, limit, currentPage]);

    return (
        <>
            <div className='main-content'>
                <ProjectViewHeader IsBtnShow={true} Title='Project view' Count={projectList?.count} src={Export} BtnTxt='Export' url={'/project-view'} />
                <Divider sx={{ color: '#D9D7DD' }} opacity={2} my={[3, 3, 4]} />
                <DataTable
                    loader={loader}
                    columns={columns}
                    data={projectList?.data || []}
                    TotalLength={projectList?.count || 15}
                    perPageCount={limit || 15}
                    currentPage={currentPage || 1}
                    onPerPageChange={(itemsPerPage) => {
                        const parsedQuery = queryString.parse(location.search);
                        if (searchParams?.size > 2) {

                            setSearchParams({
                                ...parsedQuery,
                                limit: itemsPerPage.toString(),
                            });
                        } else if (projectList?.count < itemsPerPage) {
                            setSearchParams({
                                currentPage: '1',
                                limit: itemsPerPage.toString(),
                            });
                        }
                        else {
                            setSearchParams({
                                ...parsedQuery,
                                currentPage: currentPage.toString(),
                                limit: itemsPerPage.toString(),
                            });
                        }

                    }}
                    onPageChange={(value) => {
                        const parsedQuery = queryString.parse(location.search);
                        if (searchParams?.size > 2) {

                            setSearchParams({
                                ...parsedQuery,
                                currentPage: value.toString(),
                            });
                        } else {
                            setSearchParams({
                                ...parsedQuery,
                                currentPage: value.toString(),
                                limit: limit.toString(),
                            });
                        }

                    }} />
            </div>
            {/* {isOpen && <EditModal isOpen={isOpen} projectId={projectId} onModelClose={() => {
                setIsOpen(false)
                navigate("/project-view")
                setProjectId("")
            }} />} */}
            {/* {isOpen && <EditTaskView taskId={taskId} onModelClose={() => {
                setIsOpen(false)
                navigate("/task-view")
                setTaskId("")
            }} */}
        </>
    )
};

export default Index;